export const navLinks = [
  { label: "下载入口", href: "#entry" },
  { label: "安装教程", href: "#install" },
  { label: "最新地址", href: "#address" },
  { label: "常见问题", href: "#faq" },
];

export const guideIndex = [
  { id: "idx-1", label: "官方入口怎么找", desc: "先认准本页整理的入口，别从搜索结果乱点", href: "#entry" },
  { id: "idx-2", label: "各版本下载对照", desc: "安卓、iOS、网页版、大屏版的区别一次看清", href: "#entry" },
  { id: "idx-3", label: "APP 安装步骤", desc: "从下载到打开，四步走完不踩坑", href: "#install" },
  { id: "idx-4", label: "最新地址更新", desc: "线路变动的时间线，建议收藏本页", href: "#address" },
  { id: "idx-5", label: "常见问题解答", desc: "装不上、打不开、找不到，都有答案", href: "#faq" },
];

export const heroStats = [
  { id: "hs-1", value: "4", unit: "种", label: "版本形态" },
  { id: "hs-2", value: "4", unit: "步", label: "安装流程" },
  { id: "hs-3", value: "6", unit: "问", label: "高频答疑" },
];

export const platformCards = [
  {
    id: "android",
    platform: "Android",
    title: "安卓版下载",
    tag: "APK 直装",
    desc: "适合绝大多数国产与海外安卓机型，下载安装包后按提示直接装，占用空间也比较小。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20illustration%20of%20a%20modern%20smartphone%20floating%20on%20a%20clean%20warm%20cream%20background%2C%20soft%20orange%20and%20terracotta%20gradient%20glow%2C%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20editorial%20tech%20poster%20style%2C%20harmonious%20composition%2C%20generous%20negative%20space%2C%20high%20detail&width=800&height=600&seq=qiezi-android-card&orientation=landscape",
    points: ["覆盖主流安卓机型的安装包", "下载后按提示允许安装来源", "新版本可覆盖安装直接更新"],
  },
  {
    id: "ios",
    platform: "iOS",
    title: "iOS 版下载",
    tag: "引导安装",
    desc: "面向 iPhone 与 iPad 用户，跟随系统设置完成安装与信任，整个流程留意页面提示即可。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20illustration%20of%20a%20sleek%20glass%20pane%20device%20on%20a%20soft%20warm%20beige%20background%2C%20muted%20coral%20and%20sand%20tones%2C%20delicate%20geometric%20lines%2C%20gentle%20lighting%2C%20modern%20editorial%20tech%20aesthetic%2C%20calm%20balanced%20composition%2C%20ample%20negative%20space%2C%20refined%20detail&width=800&height=600&seq=qiezi-ios-card&orientation=landscape",
    points: ["适配 iPhone 与 iPad 屏幕", "按引导完成信任设置", "建议保持系统版本较新"],
  },
  {
    id: "web",
    platform: "Web",
    title: "网页版入口",
    tag: "免安装",
    desc: "不想占用手机存储？浏览器直接打开就能浏览内容，临时看一看的时候最省事。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20illustration%20of%20a%20browser%20window%20interface%20on%20a%20clean%20warm%20ivory%20background%2C%20soft%20brick%20red%20and%20cream%20tones%2C%20thin%20outline%20geometry%2C%20subtle%20texture%2C%20modern%20editorial%20tech%20poster%20style%2C%20calm%20composition%2C%20generous%20negative%20space%2C%20refined%20detail&width=800&height=600&seq=qiezi-web-card&orientation=landscape",
    points: ["无需下载、不占存储空间", "常见浏览器均可正常打开", "设备之间方便随时切换"],
  },
  {
    id: "tv",
    platform: "TV",
    title: "大屏 / TV 版",
    tag: "遥控适配",
    desc: "想在家里的大屏上放松一下？大屏版针对遥控器操作做了适配，画面会跟着屏幕尺寸走。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20illustration%20of%20a%20widescreen%20monitor%20on%20a%20light%20warm%20neutral%20background%2C%20soft%20sage%20green%20and%20amber%20accents%2C%20clean%20geometric%20forms%2C%20subtle%20paper%20texture%2C%20modern%20editorial%20tech%20poster%2C%20balanced%20composition%2C%20lots%20of%20negative%20space%2C%20refined%20detail&width=800&height=600&seq=qiezi-tv-card&orientation=landscape",
    points: ["适配遥控器方向键操作", "大屏画面自动铺满适配", "家庭网络下加载更顺畅"],
  },
];

export const installSteps = [
  {
    id: "step-1",
    no: "01",
    title: "认准官方入口",
    desc: "从本页给出的入口进入，不要随手点开搜索结果里来历不明的仿冒站点，这是最关键的一步。",
  },
  {
    id: "step-2",
    no: "02",
    title: "选择对应版本",
    desc: "按自己手中的设备挑选安卓版、iOS 版或网页版，不清楚差别可以先看上面的版本对照。",
  },
  {
    id: "step-3",
    no: "03",
    title: "下载并完成安装",
    desc: "下载完成后按系统弹出的提示走完安装流程，安卓留意安装来源权限，iOS 留意信任设置。",
  },
  {
    id: "step-4",
    no: "04",
    title: "打开并确认可用",
    desc: "能正常进入就说明装好了；如果打不开或闪退，回到本页的常见问题按提示逐条排查。",
  },
];

export const addressUpdates = [
  { id: "addr-1", date: "2026-10-08", title: "主域名线路更新", note: "优化了访问速度，旧地址可能逐步停用，建议以本页为准。" },
  { id: "addr-2", date: "2026-09-21", title: "新增备用入口", note: "增加了一条备用线路，避免单一地址临时失效时无处可去。" },
  { id: "addr-3", date: "2026-09-05", title: "移动端适配优化", note: "手机端打开更贴合屏幕，按钮点击区域做了放大。" },
  { id: "addr-4", date: "2026-08-18", title: "大屏版本上线", note: "大屏 / TV 版入口整理完成，遥控器操作更顺手。" },
];

export const faqItems = [
  {
    id: "faq-1",
    q: "茄子视频下载找不到官方入口怎么办？",
    a: "优先从本页整理好的入口进入，尽量不要使用搜索结果里来源不明的第三方站点，避免下载到被改动过的安装包。",
  },
  {
    id: "faq-2",
    q: "最新地址会不会经常变化？",
    a: "线路会不定期更新，本页会同步整理最新可用的地址，建议把本页收藏起来，需要的时候直接打开即可。",
  },
  {
    id: "faq-3",
    q: "安卓版安装时提示「未知来源」怎么办？",
    a: "这是安卓系统对非应用商店安装包的保护提示。在系统设置中允许该来源安装即可，安装完成后可以再把这项权限关掉。",
  },
  {
    id: "faq-4",
    q: "iOS 版安装后打不开是什么原因？",
    a: "多数情况是描述文件信任设置还没完成，按引导补上即可；如果系统版本过旧，也建议先升级到较新的版本再试。",
  },
  {
    id: "faq-5",
    q: "不安装 APP 可以直接用吗？",
    a: "可以。网页版免安装，用浏览器打开就能浏览内容，适合临时使用或者不想占用手机存储的情况。",
  },
  {
    id: "faq-6",
    q: "下载速度慢、加载卡顿怎么处理？",
    a: "通常和本地网络环境有关，可以尝试切换 Wi-Fi 与移动网络，或者稍后再试；大屏版建议连接家庭网络使用。",
  },
];

export const safetyNotes = [
  { id: "safe-1", icon: "ri-shield-check-line", text: "只认准本页整理的官方入口，不轻信陌生链接。" },
  { id: "safe-2", icon: "ri-device-line", text: "按自己的设备型号选择版本，不要混装。" },
  { id: "safe-3", icon: "ri-refresh-line", text: "地址有变动会第一时间更新，收藏本页更省心。" },
];